import Vue from 'vue';
import Component from 'vue-class-component';
import ClientListContainer from '@/components/ClientListContainer/ClientListContainer';


@Component({
    components: {
        ClientListContainer
    }
})
export default class Clients extends Vue {
}